import styles from './Card.module.scss.js';
import cx from 'classnames';
import { Variant, Elevation, Rounded } from './types.js';
import { jsx } from 'react/jsx-runtime';

const Card = (props) => {
  const {
    children,
    className,
    elevation = Elevation.none,
    rounded = Rounded.sm,
    testId = "ogFeLibraryCardComponent",
    variant = Variant.outlined,
    fullWidth = false
  } = props;
  const cardStyles = cx(className, styles.card, styles[variant], styles[rounded], {
    [styles[elevation]]: variant === Variant.elevation,
    [styles.fullWidth]: fullWidth
  });
  return /* @__PURE__ */ jsx("div", {
    "data-test-id": testId,
    className: cardStyles,
    children
  });
};

export { Card as default };
//# sourceMappingURL=Card.js.map
